define('customersDetailBodyContactInfoView',[
  'module',
  'app',
  'marionette',
  'template!customersDetailBodyContactInfoView'
], function(
  module,
  App,
  Marionette,
  infoTabTpl
) {
  'use strict';

  var CustomersContactsInfoTabView = Marionette.ItemView.extend({
    template: infoTabTpl,

    triggers: {
      'click @ui.editBtn' : '_onEditContactInfo'
    },

    ui: {
      editBtn: '.js-edit'
    },

    events: {
      'click .phone-number': 'onPhoneNumberClick'
    },

    onPhoneNumberClick: function() {
      App.trigger('phone:numbering', { phoneNumber: this.model.get('tel') });
    },

    serializeData: function() {
      return this.model.toJSON();
    }
  });

  module.exports = CustomersContactsInfoTabView;
});
